import {auth} from '@neosvoc/nv-platform-core-common';

export const userHasPermission = (roles, permission) => {
    const permissions = auth.getPermissions(...roles);
    return permissions.includes(permission);
};
